import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import {
   getCategoryForAddQuizzes,
  requestAddQuizz,
  requestEditQuizz,
} from "../../redux/actions/quizzesActionCreators";
import { fetchAllIcons } from "../../redux/actions/iconsActionCreators";
import { useHistory } from "react-router-dom";
import DialogContentText from "@mui/material/DialogContentText";
import { useMediaQuery } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {  Autocomplete } from '@mui/material';


export default function AddModal({
  open,
  handleClose,
  initialValues,
  isUpdate,
  quizzId,
  title,
  newVersion,
  iconUrl,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const icons = useSelector((state) => state.icons.all);
  const isAuth = useSelector((state) => state.user.isAuth);

  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;
  const accountId = JSON.parse(storedUser)?.account_id;
  const account_role = JSON.parse(localStorage.getItem("user"))?.role;
  const orgaId = localStorage.getItem("orgaId");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [icon, setIcon] = useState("");
  const [error, setError] = useState(false);

  const isMobile = useMediaQuery("(max-width:900px)");
  const lang = localStorage.getItem("i18nextLng")

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    setIcon(iconUrl);
  }, [iconUrl]);

  useEffect(() => {
    if(isAuth){
      dispatch(fetchAllIcons());
    }
  }, [dispatch,isAuth]);

  const handleIcon = (item) => {
    setError(false);
    setIcon(item);
    setAnchorEl(null);
  };

  const handleClosePop = () => {
    setAnchorEl(null);
  };
  const openPop = Boolean(anchorEl);
  const id = openPop ? "simple-popover" : undefined;


  const [addingNewCategory, setAddingNewCategory] = useState(false);
  const categories = useSelector((state) => state.quizzes.categories_add_quizzes);



    useEffect(async () => {
      if (account_role === "cytailor_admin"){
      await dispatch(getCategoryForAddQuizzes())
        }
    }, [dispatch]);





  let error_message = "";
  let  filter='^[a-zA-Z0-9\u00C0-\u00FF\u0152\u0153][a-zA-Z0-9\\s\u00C0-\u00FF\u0152\u0153]*$'
  lang ==="fr"?  error_message="Entrée invalide ! Elle doit commencer par une lettre ou un chiffre et ne contenir que des lettres, des chiffres et des espaces.":
      error_message="Invalid input! It must start with a letter or a number and contain only letters, numbers, and spaces."

  // lang ==="fr"?  filter='^[a-zA-Z0-9\s\u00C0-\u00FF\u0152\u0153]+$':
  //     filter='^[a-zA-Z0-9\\s]+$'

  let category_condition = account_role === "cytailor_admin"?Yup.string().matches(filter, error_message).required(t("required_field")):Yup.string().matches(filter, error_message)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object({
      title: Yup.string().required(t("required_field")),
      description: Yup.string().required(t("required_field")),
      category: category_condition,
      // add_new_category: Yup.string().matches('^[a-zA-Z0-9\s\u00C0-\u00FF\u0152\u0153]+$', error_message).nullable(),
    }),
    onSubmit: (values, { resetForm }) => {
      if (!error) {
        if (isUpdate) {
          dispatch(
            requestEditQuizz(
              isAuth,
              values,
              quizzId,
              accountId,
              accountType,
              orgaId,
              icon
            )
          );
          setError(false);
        } else {
          dispatch(
            requestAddQuizz(
              {
                ...values,
                usecases: [],
                icon_url: icon,
              },
              history,
              accountType,
              accountId
            )
          );
        }
        handleClose();
        setError(false);
      }
    },
  });
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        PaperProps={{ sx: { padding: "20px " } }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>
            <Typography variant="title4">{t("add_quizz")}</Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText mb={3}>
              {t("add_quiz_description")}
            </DialogContentText>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ padding: "5px 0px" }}>
                  {t("quiz_name")}
                </Typography>
                <TextField
                  error={Boolean(formik.touched.title && formik.errors.title)}
                  fullWidth
                  helperText={formik.touched.title && formik.errors.title}
                  name="title"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.title}
                  disabled={!!newVersion}
                />
              </Grid>

              {isMobile ? (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    style={{ padding: "5px 0px" }}
                  >
                    Select Icon
                  </Typography>
                  <div
                    className={
                      error ? "imageErrorMobile" : "imageContainerMobile"
                    }
                  >
                    {icons.map((el) => (
                      <div
                        className={el === icon ? "selectedMobile" : "imageMap"}
                        onClick={() => handleIcon(el)}
                      >
                        <img
                          alt=""
                          src={el}
                          style={{
                            width: "70px",
                            height: "70px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    style={{ padding: "5px 0px" }}
                  >
                    Select Icon
                  </Typography>
                  <div className={error ? "imageError" : "imageContainer"}>
                    {icons.map((el) => (
                      <div
                        className={el === icon ? "selected" : "imageMap"}
                        onClick={() => handleIcon(el)}
                      >
                        <img
                          alt=""
                          src={el}
                          style={{
                            width: "70px",
                            height: "70px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </Grid>
              )}
              {error && (
                <p className="error-message-icon">{t("required_field")}</p>
              )}


              {account_role === "cytailor_admin" &&(
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" style={{ padding: "5px 0px" }}>
                      {t("quiz_category")}
                    </Typography>
                    <Autocomplete
                        id="category"
                        name="category"
                        options={categories}
                        freeSolo
                        getOptionLabel={(option) =>
                            typeof option === "string"
                                ? option
                                : lang === "fr"
                                    ? option.value_fr
                                    : option.value
                        }
                        onChange={(event, newValue) => {
                          setAddingNewCategory(false);

                          formik.setFieldValue(
                              "category",
                              newValue
                                  ? typeof newValue === "string"
                                      ? newValue
                                      : lang === "fr"
                                          ? newValue.value_fr
                                          : newValue.value
                                  : ""
                          );
                        }}
                        value={
                            categories.find(
                                (option) =>
                                    (lang === "fr" ? option.value_fr : option.value) === formik.values.category
                            ) || formik.values.category || null
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                onChange={(event) => {
                                  formik.setFieldValue("category", event.target.value);
                                }}
                                onBlur={formik.handleBlur}
                                placeholder={t("categories_placeholder")}
                                error={Boolean(formik.touched.category && formik.errors.category)}
                                helperText={formik.touched.category && formik.errors.category}
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                    {/*{addingNewCategory && (*/}
                    {/*    <>*/}
                    {/*      <Typography variant="subtitle2" style={{ padding: "5px 0px" }}>*/}
                    {/*        {t("new_category")}*/}
                    {/*      </Typography>*/}
                    {/*      <TextField*/}
                    {/*          fullWidth*/}
                    {/*          name="add_new_category"*/}
                    {/*          value={formik.values.add_new_category}*/}
                    {/*          onBlur={formik.handleBlur}*/}
                    {/*          onChange={formik.handleChange}*/}
                    {/*          error={Boolean(*/}
                    {/*              formik.touched.add_new_category && formik.errors.add_new_category*/}
                    {/*          )}*/}
                    {/*          helperText={*/}
                    {/*              formik.touched.add_new_category && formik.errors.add_new_category*/}
                    {/*          }*/}
                    {/*          variant="outlined"*/}
                    {/*          style={{ marginTop: "10px" }}*/}
                    {/*      />*/}
                    {/*    </>*/}
                    {/*)}*/}
                  </Grid>


              )}



              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ padding: "5px 0px" }}>
                  Description
                </Typography>
                <TextField
                  error={Boolean(
                    formik.touched.description && formik.errors.description
                  )}
                  fullWidth
                  helperText={
                    formik.touched.description && formik.errors.description
                  }
                  name="description"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  multiline
                  rows={4}
                  disabled={!!newVersion}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ padding: "20px" }}>
            <Grid container>
              <Grid item xs={12}>
                <Button
                  onClick={() => !!!icon && setError(true)}
                  variant="contained"
                  color="button"
                  type="submit"
                  fullWidth
                >
                  {t("save")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
